import React, { use, useEffect, useState, useRef } from "react";
import { Sidebar } from "../../common/Sidebar";
import { Navbar } from "../../common/Navbar";
import { Nav } from "react-bootstrap";
import back from "../../../assets/svg/backArrow.svg";
import user from "../../../assets/svg/user.svg";
import brush from "../../../assets/svg/brush.svg";
import { ReactComponent as SearchIc } from "../../../assets/svg/search.svg";

import { Card, Dropdown, Spinner, Table, Toast, ToastContainer, ProgressBar, Modal, Button, Form, InputGroup } from "react-bootstrap";
import { ChevronDown, ChevronUp } from "lucide-react";
import bottle from "../../../assets/svg/bottle.svg";
import "./viewProject.css";
import smallLogo from "../../../assets/svg/vguardSmall.svg";
import { deleteProjectApi, getProjectExpenseApi, getProjectViewApi, getTransDetailsApi, getBudgetApi, addBudgetApi, getProjectEditApi, getProjectStageApi, updateStageApi } from "./projectApi";
import { useLocation, useNavigate } from "react-router-dom";
import productDefault from "../../../assets/png/product_default.png";
import profileIc from "../../../assets/png/profile-ic.png";
import { ReactComponent as ThreeDotIC } from "../../../assets/svg/three-dot-ic.svg";
import downloadBlack from "../../../assets/svg/blackDownload.svg";
import deleteIc from "../../../assets/svg/delete-po.svg";
import DeleteModal from "../../common/deleteModel";
import CommonDropdown from "../../common/common_dropDown";
import { ReactComponent as ImportIc } from "../../../assets/svg/import_ic.svg";
import { ReactComponent as DownloadIc } from "../../../assets/svg/download_Ics.svg";
import { downloadTemplateExcelApi, uploadExcelApi } from "../../transaction/transaction_api";
import numberFormat from "../../common/number-format.js";
import { ReactComponent as DownArrow } from "../../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as EditIc } from "../../../assets/svg/edit_ic.svg";
import EditItemModal from "./editModel.jsx";

export const ViewProject = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isLoading, setIsLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditId, setShowEditId] = useState(-1);
  const [search, setSearch] = useState("");

  const location = useLocation();
  const projectId = location.state?.id;
  const [barValues, setBarValues] = useState([]);
  const [barMaxValue, setBarMaxValue] = useState(0);
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [openCardId, setOpenCardId] = useState(null);
  const [projectDetails, setProjectDetails] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [revisions, setRevisions] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isExportLoad, setIsExportLoad] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [statusOption, setStageOption] = useState([]);
  const [activeTab, setActiveTab] = useState();
  const [tabs, setTabs] = useState([]);
  const [statusSelect, setStatusSelect] = useState(null);
  const [show, setShow] = useState(false);
  const [productList, setProductList] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [removedProductList, setRemovedProductList] = useState([]);

  const [selectAll, setSelectAll] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  //  first chart states
  const [projectValue, setProjectValue] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [profitPercent, setProfitPercent] = useState(0);

  const mapBudgetsToProductList = (budgetsArr) =>
    (budgetsArr || []).map((p) => ({
      id: p.id ?? 0,
      product: p.product ? { value: p.product_id, label: p.product } : (p.product ?? null),
      unit: p.uom_label ? { value: p.uom_value, label: p.uom_label } : (p.uom_label ?? null),
      quantity: p.actual_qty ?? null,
      amount: p.actual_amount ?? null,
    }));

  useEffect(() => {
    if (showEditId !== -1) {
      setShowEditModal(true);
    }
  }, [showEditId]);
  useEffect(() => {
    getProjectList();
  }, []);
  useEffect(() => {
    if (budgets && budgets.length > 0) {
      setProductList(mapBudgetsToProductList(budgets));
      setRemovedProductList([]);
      setSelectAll(false);
      setSelectedProducts([]);
    }
  }, [budgets]);
  useEffect(() => {
    if (statusSelect) {
    }
  }, [statusSelect]);

  const groupedProducts = budgets.reduce((acc, item) => {
    if (!acc[item.product_group]) {
      acc[item.product_group] = [];
    }
    acc[item.product_group].push(item);
    return acc;
  }, {});

  const productGroups = Object.keys(groupedProducts);

  const [activeGroup, setActiveGroup] = useState(productGroups[0]);

  useEffect(() => {
    if (productGroups.length && !activeGroup) {
      setActiveGroup(productGroups[0]);
    }
  }, [productGroups, activeGroup]);

  // Add this function to handle the select all checkbox
  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      setSelectedProducts(productList.map((product) => product.id));
    } else {
      setSelectedProducts([]);
    }
  };

  // Add this function to handle individual checkbox selection
  const handleProductSelect = (productId, checked) => {
    if (checked) {
      setSelectedProducts([...selectedProducts, productId]);
    } else {
      setSelectedProducts(selectedProducts.filter((id) => id !== productId));
    }
  };

  const getErrorMsg = (index, field) => {
    // Add your error handling logic here
    return "";
  };

  //Api
  const updateProjectStatus = async (id, value) => {
    const bodyData = { stage_id: value };

    try {
      const response = await updateStageApi(id, bodyData);

      if (response?.data?.success === true) {
        setSnackbarMessage(response?.data?.message || "");
        setSnackbarStatus(true);

        // 🔄 Refresh vendor list
        await getProjectView(id);

        // ✅ Optional: optimistic update instead of API refetch
        // setVendors(prev =>
        //   prev.map(v => v.id === id ? { ...v, stage: value } : v)
        // );
      } else {
        setSnackbarMessage(response?.data?.message || "");
        setSnackbarStatus(false);
      }
    } catch (error) {
      console.error("Error updating vendor status:", error);

      setSnackbarMessage(error?.response?.data?.message || "");
      setSnackbarStatus(false);
    } finally {
      handleSnackbarShow(); // 🔔 ensure snackbar opens
    }
  };

  const getProjectView = async (id) => {
    try {
      const response = await getProjectViewApi(id);

      if (response.data.success === true) {
        const projectDetail = response.data.project ?? {};
        setProjectDetails(projectDetail);

        setStatusSelect({
          value: projectDetail.stage_id,
          label: projectDetail.stage,
        });
        const revisions = projectDetail.revision ?? [];
        setTabs(revisions);

        setActiveTab(revisions.length > 0 ? revisions[0].revision : null);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  //get transactions
  const getTransactionList = async (itemId) => {
    try {
      const response = await getTransDetailsApi(itemId, id);

      if (response.data.success === true) {
        setTransactions([]);
        setTransactions(response.data.transactions ?? []);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  //get budgets

  const getBudgets = async (id) => {
    try {
      setIsLoading(true);
      const response = await getBudgetApi(id, search);

      if (response.data.success === true) {
        setBudgets(response.data.products ?? []);
        console.log("response.data.products", response.data.products);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getProjectList = async (id) => {
    try {
      setIsLoading(true);
      const response = await getProjectStageApi();

      if (response.data.success === true) {
        setStageOption(response.data.suggestionlist ?? []);
        console.log("response.data.suggestionlist", response.data.suggestionlist);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  //download project expenses
  const getProjectExpensedownload = async (revisionId) => {
    setIsExportLoad(true);

    try {
      const response = await getProjectExpenseApi(id, revisionId);
      const data = response?.data;

      if (data?.success) {
        setSnackbarMessage(data.message || "Download successful");
        setSnackbarStatus(true);
        handleSnackbarShow();
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = response.data.file_name || "Report_" + new Date().getTime() + ".xlsx";

        // Convert Base64 to Blob
        const binary = atob(base64String);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        const blob = new Blob([new Uint8Array(array)], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link and trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setSnackbarMessage(data?.message || "Download failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Error fetching project expense:", error);
      setSnackbarMessage("Something went wrong while downloading");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsExportLoad(false);
    }
  };
  //delete project
  const deleteProject = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteProjectApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        navigate(-1);
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  //add budget
  const submitBudgets = async () => {
    setIsLoading(true);
    try {
      const productsPayload = productList.map((item) => ({
        ...item,
        product_id: item.product?.value || null,
        unit_id: item.unit?.value || null,
        qty: Number(item.quantity || 0),
        amount: String(item.amount || 0),
      }));

      const payload = {
        products: productsPayload,
        removed_products: removedProductList || [],
      };

      const response = await addBudgetApi(projectDetails.id, payload);

      if (response?.data?.success) {
        setSnackbarMessage(response.data.message || "Budgets updated");
        setSnackbarStatus(true);
        handleSnackbarShow();
        getBudgets(activeRevision.id);
        setShow(false);
        setProductList([]);
        setRemovedProductList([]);
        setSelectAll(false);
        setSelectedProducts([]);
        getProjectView(id);
      } else {
        setSnackbarMessage(response?.data?.message || "Failed to update budgets");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error submitting budgets:", err);
      setSnackbarMessage("Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect
  const downloadBase64File = (base64String) => {
    const binary = atob(base64String);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Transaction_" + new Date().getTime() + ".xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const downloadTemplateExcel = async () => {
    setIsDownloading(true);
    const response = await downloadTemplateExcelApi("Transaction");
    setIsDownloading(false);
    if (response.status === 200) {
      if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = "Transaction" + "_template_" + new Date().getTime() + ".xlsx";

        // Convert Base64 to Blob
        downloadBase64File(base64String, fileName);
      }
    }
  };
  useEffect(() => {
    if (id != null) {
      getProjectView(id);
    }
  }, [id]);

  useEffect(() => {
    if (openCardId !== null) {
      getTransactionList(openCardId);
    }
  }, [openCardId]);

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const [activeRevision, setActiveRevision] = useState(null);

  useEffect(() => {
    if (activeTab && projectDetails.revision) {
      const revision = projectDetails.revision.find((rev) => rev.revision === activeTab);
      if (revision) {
        setActiveRevision(revision);
        var barValueTemp = [Number(projectDetails.project_cost) || 0, Number(projectDetails.marginal_cost) || 0, Number(projectDetails.product_amount) || 0, Number(projectDetails.project_value) || 0];
        setBarValues(barValueTemp);
        setBarMaxValue(Math.max(...barValueTemp));

        setRevisions([
          {
            id: revision.id,
            product: revision.revision,
            actual_qty: revision.actual_qty,
            actual_amount: revision.actual_amount,
            spent_qty: revision.spent_qty,
            spent_amount: revision.spent_amount,
            balance_qty: revision.balance_qty,
            balance_amount: revision.balance_amount,
            ctc_amount: revision.ctc_amount,
            transaction: 0,
          },
        ]);
      }
    }
  }, [activeTab, projectDetails]);

  useEffect(() => {
    if (activeRevision && activeRevision.id) {
      getBudgets(activeRevision.id);
    }
  }, [activeRevision, search]);

  const handleTabClick = (revisionName) => {
    setActiveTab(revisionName);
    const revision = projectDetails.revision?.find((rev) => rev.revision === revisionName);
    if (revision) {
      setActiveRevision(revision);
    }
  };

  const actual = Number(activeRevision?.actual_amount ?? 0);
  const spent = Number(activeRevision?.spent_amount ?? 0);
  const rawPercent = actual > 0 && isFinite(actual) ? (spent / actual) * 100 : 0;
  const widthPercent = Math.max(0, Math.min(100, Number(rawPercent.toFixed(2))));

  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!projectId) return;

      try {
        const response = await getProjectEditApi(projectId);
        const project = response?.data?.project;
        if (!project) return;
        const projectValueCalc = parseFloat(project.project_value) || 0;
        const productAmount = parseFloat(project.product_amount) || 0;
        let profit = project.profit;
        if (profit === undefined || profit === null || profit === "") {
          profit = projectValueCalc - productAmount;
        }
        profit = parseFloat(profit);
        setProjectValue(projectValueCalc.toFixed(2));
        setTotalCost(productAmount.toFixed(2));
        setProfitPercent(profit.toFixed(2));
      } catch (error) {
        console.error("Error fetching project details:", error);
      }
    };
    fetchProjectDetails();
  }, [projectId]);

  const fileInputRef = useRef(null);

  const handleFileChange = (event, responseMsg) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // this will be the byte code (base64String)

        uploadExcel(base64String, responseMsg);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid excel file.");
    }
    fileInputRef.current.value = "";
  };
  const uploadExcel = async (base64String) => {
    setIsUploading(true);
    const response = await uploadExcelApi("transaction_upload", base64String);
    setIsUploading(false);
    if (response.status === 200) {
      if (response.data.success === true) {
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = response.data.file_name;

        // Convert Base64 to Blob
        downloadBase64File(base64String);

        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } else {
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      if (response.data.base64 != null && response.data.base64 !== "") {
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = "Transaction_" + new Date().getTime() + ".xlsx";

        // Convert Base64 to Blob
        const binary = atob(base64String);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        const blob = new Blob([new Uint8Array(array)], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link and trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };
  return (
    <>
      {" "}
      {showEditModal && (
        <EditItemModal
          id={showEditId}
          onClose={() => {
            setShowEditId(-1);
            setShowEditModal(false);
          }}
          onSave={(response) => {
            setSnackbarMessage(response.data.message);
            setSnackbarStatus(response.data.success);
            handleSnackbarShow();
            if (response.data.success === true) {
              getProjectView(id);
            }
            setShowEditId(-1);
            setShowEditModal(false);
          }}
        />
      )}
      <DeleteModal title={"project"} isOpen={isOpenDelete} onClose={() => setIsOpenDelete(false)} onDelete={deleteProject} />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Project" />
        {/* Main Content */}
        <div className="rounded-4 flex-grow-1">
          <div style={{ backgroundColor: "#F5F8FA" }}>
            <Navbar pageTitle="Project" />
            <div
              style={
                {
                  // overflow: "auto",
                  // maxHeight: "100%",
                }
              }
            >
              <div className="bg-white p-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      onClick={() => navigate(-1)}
                      src={back}
                      alt="back"
                      className="p-3 rounded-circle"
                      style={{
                        cursor: "pointer",
                        border: "1px solid #EBEBEB",
                      }}
                    />
                    <div className="d-flex gap-3 align-items-center">
                      <div className="p-3 rounded-circle" style={{ backgroundColor: "#F4F4F4" }}>
                        {projectDetails.name && projectDetails.name.trim() !== ""
                          ? projectDetails.name
                              .trim()
                              .split(" ")
                              .flatMap((word) => word.charAt(0).toUpperCase())
                              .join("") // join all initials
                              .padEnd(2, projectDetails.name.trim().charAt(1)?.toUpperCase() || "") // ensure 2 letters
                              .slice(0, 2)
                          : "-"}
                      </div>
                      <div className="d-flex flex-column">
                        <p className="m-0 fs-16 fw-400">{projectDetails.name ?? "-"}</p>
                        <p className="textGrey m-0 fs-12 fw-400">
                          Code <span className="ps-1">:</span>
                          <span className="textPurple fs-12 fw-500 ps-1">{projectDetails.code ?? "-"}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    {/* <button
                    className="border-0 text-white px-3 py-1 rounded-pill"
                    style={{ backgroundColor: "#4F46E5" }}
                  >
                    <img src={edit} alt="edit" /> Edit
                  </button> */}
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between rounded-5"
                          style={{
                            border: "1px solid #EBEBEB",
                            backgroundColor: "white",
                            padding: "6px 12px",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span className="dropdown-text textcolor fs-13 fw-500">{!statusSelect?.label || statusSelect.label === "-" ? "Update Stage" : statusSelect.label}</span>

                            <span className="dropdown-toggle-arrow">
                              <DownArrow />
                            </span>
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {statusOption.map((option) => (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              key={option.value}
                              onClick={() => {
                                updateProjectStatus(id, option.value);
                                setStatusSelect(option);
                              }}
                              active={statusSelect?.value === option.value}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                          style={{
                            width: "36px",
                            height: "36px",
                            border: "1px solid #EBEBEB",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <ThreeDotIC />
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              navigate("/project/create", {
                                state: { id: projectDetails.id, isClone: true },
                              });
                            }}
                          >
                            Clone
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              navigate("/project/create", {
                                state: { id: projectDetails.id },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={() => {
                              setDeleteId(projectDetails.id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center mt-3">
                  <div className="d-flex px-3 py-2 gap-2 align-items-center rounded-pill" style={{ backgroundColor: "#F7F7F7" }}>
                    <img src={user} alt="" style={{ width: "12px", height: "12px" }} />
                    <p className="m-0 fs-12 fw-400 textltcolor">Admin</p>
                    <p className="m-0 fs-12 fw-400 textltcolor">:</p>
                    <p className="m-0 fs-13 fw-500 textPurple"> {projectDetails.admin ?? "-"}</p>
                  </div>
                  <div
                    style={{
                      width: "1px",
                      height: "20px",
                      backgroundColor: "#EBEBEB",
                    }}
                  ></div>
                  <div className="d-flex px-3 py-2 gap-2 align-items-center rounded-pill" style={{ backgroundColor: "#F7F7F7" }}>
                    <img src={user} alt="" style={{ width: "12px", height: "12px" }} />

                    <p className="m-0 fs-12 fw-400 textltcolor">Manager</p>
                    <p className="m-0 fs-12 fw-400 textltcolor">:</p>
                    <p className="m-0 fs-13 fw-500 textPurple"> {projectDetails.manager ?? "-"}</p>
                  </div>
                </div>
              </div>
              <div className="row w-100 p-3">
                <div className="col-xl-12 mb-3">
                  <div className="bg-white p-4 rounded-4">
                    <p className="text-xl fw-bold mb-4">Project details</p>

                    <div className="row">
                      {/* Left Section */}
                      <div className="col-md-4">
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Project value</span>
                          <span className="fw-semibold">₹{numberFormat(projectDetails.project_cost_formatted)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Margin Pct. (%)</span>
                          <span className="fw-semibold">{numberFormat(projectDetails.marginal_cost_percentage_formatted)} %</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Margin Planned</span>
                          <span className="fw-semibold">₹{numberFormat(projectDetails.marginal_cost_formatted)}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Budget amount</span>
                          <span className="fw-semibold">₹ {numberFormat(projectDetails.product_amount_formatted)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Cost to complete</span>
                          <span className="fw-semibold">₹ {numberFormat(projectDetails.project_value_formatted)}</span>
                        </div>
                      </div>
                      <div className="d-none d-md-flex justify-content-center" style={{ flex: "0 0" }}>
                        <div
                          style={{
                            width: "1px",
                            backgroundColor: "#E0E0E0",
                            height: "100%",
                          }}
                        ></div>
                      </div>
                      {/* Right Section */}
                      <div className="col-md-4">
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Claimed Amount</span>
                          <span className="fw-semibold">₹ {numberFormat(projectDetails.claimed_amount) ?? 0}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Retention Amount</span>
                          <span className="fw-semibold">₹ {numberFormat(projectDetails.rentention_amount) ?? 0}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Retention Due Date</span>
                          <span className="fw-semibold">{projectDetails.retention_due_date ?? "-"}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Retention Claimed Amount</span>
                          <span className="fw-semibold">₹ {numberFormat(projectDetails.rentention_claimed_amount) ?? 0}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Retention Claimed Date</span>
                          <span className="fw-semibold">{projectDetails.retention_claimed_date ?? "-"}</span>
                        </div>
                      </div>

                      <div
                        className=" d-none d-md-flex justify-content-center"
                        style={{
                          flex: "0 0 ",
                        }}
                      >
                        <div
                          style={{
                            width: "1px",
                            backgroundColor: "#E0E0E0",
                            height: "100%",
                          }}
                        ></div>
                      </div>
                      <div className="col-md-3">
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Created date</span>
                          <span className="fw-semibold">{projectDetails.created_date}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Last Updated date</span>
                          <span className="fw-semibold">{projectDetails.updated_date}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Start date</span>
                          <span className="fw-semibold">{projectDetails.start_date}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Estimation date</span>
                          <span className="fw-semibold">{projectDetails.estimated_date}</span>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-secondary fw-medium">Completed date</span>
                          <span className="fw-semibold text-success">{projectDetails.completed_date}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-12 mb-3">
                  <div className="bg-white p-3 rounded-4 d-flex align-items-center justify-content-between gap-4">
                    {/* ---------------- BAR CHART ---------------- */}
                    <div className="d-flex align-items-end gap-2" style={{ height: "110px", marginLeft: "156px" }}>
                      {barValues.map((value, index) => {
                        const colors = ["#7C3AED", "#FACC15", "#10B981", "#EF4444"];
                        const heightPercent = (value / barMaxValue) * 100; // % relative to max

                        return (
                          <div
                            key={index}
                            style={{
                              width: "36px",
                              backgroundColor: colors[index],
                              height: `${heightPercent}%`,
                              borderRadius: "40px 40px 0 0",
                            }}
                          />
                        );
                      })}
                    </div>

                    {/* ---------------- RIGHT SIDE BOXES ---------------- */}
                    <div className="d-flex flex-wrap gap-3 flex-grow-1">
                      {/* -------- Project value -------- */}
                      <div
                        className="d-flex align-items-center justify-content-between px-3 py-2 rounded-4"
                        style={{
                          backgroundColor: "#F7F6FF",
                          minWidth: "240px",
                          height: "53px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              backgroundColor: "#4F46E5",
                            }}
                          ></span>
                          <span className="fs-14 fw-500" style={{ color: "#4B5563" }}>
                            Project Value
                          </span>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <span className="fs-16 fw-700">₹{numberFormat(projectDetails.project_cost_formatted)}</span>
                        </div>
                      </div>

                      {/* -------- Budget amount -------- */}
                      <div
                        className="d-flex align-items-center justify-content-between px-3 py-2 rounded-4"
                        style={{
                          backgroundColor: "#FFF8EB",
                          minWidth: "240px",
                          height: "53px",
                          textAlign: "center",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              backgroundColor: "#FFB31F",
                            }}
                          ></span>
                          <span className="fs-14 fw-500" style={{ color: "#4B5563" }}>
                            Margin Planned
                          </span>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <span className="fs-16 fw-700">₹{numberFormat(projectDetails.marginal_cost_formatted)}</span>
                        </div>
                      </div>

                      {/* -------- Profit -------- */}
                      <div
                        className="d-flex align-items-center justify-content-between px-3 py-2 rounded-4"
                        style={{
                          backgroundColor: "#DCFCE7",
                          minWidth: "240px",
                          height: "53px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              backgroundColor: "#10B981",
                            }}
                          ></span>
                          <span className="fs-14 fw-500" style={{ color: "#4B5563" }}>
                            Budget amount
                          </span>
                        </div>
                        <div className="d-flex flex-row align-items-end" style={{ textAlign: "center" }}>
                          <span className="fs-16 fw-700">₹{numberFormat(projectDetails.product_amount_formatted)}</span>
                        </div>
                      </div>

                      {/* -------- CTC Amount -------- */}
                      <div
                        className="d-flex align-items-center justify-content-between px-3 py-2 rounded-4"
                        style={{
                          backgroundColor: "#FEE2E2",

                          minWidth: "240px",
                          height: "53px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              backgroundColor: "#EF4444",
                            }}
                          ></span>
                          <span className="fs-14 fw-500" style={{ color: "#4B5563" }}>
                            Cost to complete
                          </span>
                        </div>
                        <span className="fs-16 fw-700">₹ {numberFormat(projectDetails.project_value_formatted ?? "0")}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6">
                  <div className="btnBorder bg-white d-flex flex-column align-items-center gap-3 px-3 py-2 rounded-4">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Estimated amount</p>
                      <p className="m-0 cardTextBlue fs-16 fw-700">₹ {numberFormat(activeRevision?.actual_amount ?? "0")}</p>
                    </div>
                    <div className="position-relative w-100">
                      <div
                        style={{
                          width: "100%",
                          height: "12px",
                          backgroundColor: "#f3f4f6",
                          borderRadius: "50px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            backgroundColor: "#7c3aed",
                            borderRadius: "50px",
                            transition: "width 0.3s ease",
                            width: `${widthPercent}%`,
                          }}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Actual spent</p>
                      <p className="m-0 cardTextBlue fs-16 fw-700">₹ {numberFormat(activeRevision?.spent_amount ?? "0")}</p>
                    </div>
                    <div className="d-flex justify-content-around align-items-center w-100 gap-3">
                      <div className="col-xl-5 m-0 textcolor  fs-13 fw-400 d-flex justify-content-between py-2 px-3 rounded-4" style={{ backgroundColor: "#F9F9F9" }}>
                        <span className="fs-13 fw-300">Project completion (%)</span>
                        <span className="fs-13 fw-300">:</span>
                        <span className="fs-15 fw-500 textPurple">{projectDetails.completion_percent ?? "0"} %</span>
                      </div>
                      <div className="col-xl-5 m-0 textcolor  fs-13 fw-400 d-flex justify-content-between py-2 px-3 rounded-4" style={{ backgroundColor: "#F9F9F9" }}>
                        <span className="fs-13 fw-300">Marginal Percentage</span>
                        <span className="fs-13 fw-300">:</span>
                        <span className="fs-15 fw-500 textcolor"> {projectDetails.marginal_cost_percentage ?? "0"} %</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 mt-3 mt-xl-0 d-flex flex-column gap-3 justify-content-around">
                  <div className="btnBorder bg-white d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Spent Amount</p>
                      <p className="m-0 textcolor fs-16 fw-700"> ₹ {numberFormat(projectDetails?.spent_amount ?? "0")}</p>
                    </div>
                  </div>

                  <div className="btnBorder bg-white d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Paid amount</p>
                      <p className="m-0 textcolor fs-16 fw-700">₹ {numberFormat(projectDetails?.paid_amount ?? "0")}</p>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 mt-3 mt-xl-0 d-flex flex-column gap-3 justify-content-around">
                  <div className="btnBorder bg-white d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Committed Amount</p>
                      <p className="m-0 textcolor fs-16 fw-700"> ₹ {numberFormat(activeRevision?.committed_amount ?? "0")}</p>
                    </div>
                  </div>

                  <div className="btnBorder bg-white d-flex align-items-center gap-3 px-3 py-2 rounded-4">
                    <img src={brush} alt="brush" className="backgroundGrey p-3 rounded-3" />
                    <div className="d-flex flex-column">
                      <p className="m-0 cardTextGrey fs-13 fw-400">Pending Amount</p>
                      <p className="m-0 textcolor fs-16 fw-700">₹ {numberFormat(projectDetails?.balance_amount ?? "0")}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="mx-3 rounded-5"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  borderBottom: "1px solid #EBEBEB",
                  padding: "0 16px",
                  background: "#F8F8F8",
                  gap: "30px",
                }}
              >
                <div
                  className="d-flex"
                  style={{
                    overflowX: "auto",
                    overflowY: "hidden",
                    whiteSpace: "nowrap",
                    flexGrow: 1,
                  }}
                >
                  <Nav
                    variant="tabs"
                    style={{
                      borderBottom: "none",
                      flexWrap: "nowrap",
                      display: "flex",
                      maxWidth: 300,
                    }}
                  >
                    {tabs.map((tab) => (
                      <Nav.Item key={tab.id}>
                        <Nav.Link
                          onClick={() => handleTabClick(tab.revision)}
                          style={{
                            border: "none",
                            background: "transparent",
                            fontWeight: activeTab === tab.revision ? "500" : "500",
                            color: activeTab === tab.revision ? "#4F46E5" : "#515159",
                            padding: "12px 20px",
                            borderBottom: activeTab === tab.revision ? "3px solid #4F46E5" : "3px solid transparent",
                            borderRadius: "0",
                          }}
                        >
                          {tab.revision}
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderLeft: "2px solid #EBEBEB",
                      paddingLeft: "16px",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#4F46E5",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: "36px",
                        height: "36px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => setShow(true)}
                    >
                      <div>+</div>
                    </Button>
                  </div>
                </div>
                <div
                  className="my-import d-flex align-items-center justify-content-center gap-2"
                  style={{ height: "40px", cursor: "pointer" }}
                  onClick={() => fileInputRef.current?.click()} // ✅ Trigger file input
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ImportIc style={{ width: "16px", height: "16px" }} />
                  </div>

                  <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                    Import
                  </div>

                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={(event) => {
                      handleFileChange(event);
                    }}
                    style={{ display: "none" }}
                  />
                </div>

                <div
                  className="my-import d-flex align-items-center justify-content-center gap-2"
                  style={{ height: "40px", cursor: "pointer" }} // Optional: consistent height
                  onClick={() => {
                    downloadTemplateExcel();
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <DownloadIc
                      style={{
                        width: "16px",
                        height: "16px",
                      }}
                    />{" "}
                    {/* Smaller Icon */}
                  </div>

                  <div
                    className="fs-12 fw-600"
                    style={{ lineHeight: "16px" }} // Ensures proper vertical centering
                  >
                    Template
                  </div>
                </div>
              </div>
              {/* <div className="d-flex align-items-center gap-3 ms-auto" style={{ justifyContent: 'end', marginTop: '10px' }}>
                <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2" style={{ backgroundColor: 'white' }}>
                  <SearchIc />
                  <input
                    type="text"
                    placeholder="Search"
                    className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                    value={search || ""}
                    style={{ backgroundColor: 'white' }}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <div
                  className="border rounded-pill px-3 d-flex align-items-center justify-content-center gap-2 bg-white"
                  style={{ height: "40px", cursor: "pointer" }}
                  onClick={
                    isExportLoad
                      ? null
                      : () => getProjectExpensedownload(activeRevision.id)
                  }
                >
                  <img src={downloadBlack} alt="download" />
                  <div className="fs-14 fw-700 textcolor">
                    {isExportLoad ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Export"
                    )}
                  </div>
                </div>
              </div> */}
              <div className="d-flex align-items-center gap-3" style={{ justifyContent: "space-between", marginTop: "10px" }}>
                {/* LEFT : PRODUCT GROUP TABS */}
                <div
                  className="d-flex align-items-center"
                  style={{
                    maxWidth: "65%",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    gap: "8px",
                    marginLeft: "18px",
                  }}
                >
                  {productGroups.map((group) => (
                    <div
                      key={group}
                      onClick={() => setActiveGroup(group)}
                      className="px-3 py-2"
                      style={{
                        borderRadius: "20px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 600,
                        flexShrink: 0,
                        backgroundColor: activeGroup === group ? "#4F46E5" : "#F1F1F1",
                        color: activeGroup === group ? "#FFFFFF" : "#515159",
                      }}
                    >
                      {group === "null" || !group ? "Others" : group}
                    </div>
                  ))}
                </div>

                {/* RIGHT : SEARCH + EXPORT */}
                <div className="d-flex align-items-center gap-3 ms-auto">
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2" style={{ backgroundColor: "white" }}>
                    <SearchIc />
                    <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor" value={search || ""} onChange={(e) => setSearch(e.target.value)} style={{ backgroundColor: "white" }} />
                  </div>

                  <div className="border rounded-pill px-3 d-flex align-items-center justify-content-center gap-2 bg-white" style={{ height: "40px", cursor: "pointer" }} onClick={() => getProjectExpensedownload(activeRevision.id)}>
                    <img src={downloadBlack} alt="download" />
                    <div className="fs-14 fw-700 textcolor">Export</div>
                  </div>
                </div>
              </div>

              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <div className="p-3 d-flex flex-column">
                  {/* Scrollable content */}
                  <div
                    className="flex-grow-1 "
                    // style={{ scrollbarWidth: "thin" }}
                  >
                    {activeGroup &&
                      groupedProducts[activeGroup]
                        ?.filter((product) => product.product?.toLowerCase().includes(search?.toLowerCase() || ""))
                        .map((product) => (
                          <Card key={product.id} className="border-0 shadow-sm rounded-4 mt-3">
                            <div className="d-flex justify-content-between flex-wrap align-items-center p-3" onClick={() => setOpenCardId(openCardId === product.product_id ? null : product.product_id)} style={{ cursor: "pointer" }}>
                              {/* Left section */}
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src={product.image && product.image.trim() !== "" ? product.image : productDefault}
                                  alt="Profile"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                  }}
                                  className="profile-img"
                                />
                                <div>
                                  <h6 className="fw-400 fs-16">{product.product ?? "-"}</h6>
                                  <p className="cardTextGrey fs-12 fw-400 m-0">
                                    Actual :
                                    <span className="text-dark px-3 py-1 ms-1 fs-12 fw-400 rounded-start-pill" style={{ backgroundColor: "#F6F6F6" }}>
                                      Qty :
                                      <span className="textPurple ms-1 fs-12 fw-500">
                                        {numberFormat(product.actual_qty ?? "0")} {product.uom_label ?? "-"}
                                      </span>
                                    </span>
                                    <span className="text-dark px-3 py-1 fs-12 fw-400 rounded-end-pill ms-1" style={{ backgroundColor: "#F6F6F6" }}>
                                      Amount :<span className="textPurple ms-1 fs-12 fw-500">₹ {numberFormat(product.actual_amount_formatted ?? "0")}</span>
                                    </span>
                                  </p>
                                </div>
                              </div>
                              {/* Right section */}
                              <div className="d-flex mt-3 mt-xl-0" style={{ paddingTop: "16px" }}>
                                <div className="d-flex align-items-center border rounded-3 overflow-hidden" style={{ borderColor: "#EBEBEB" }}>
                                  {[
                                    {
                                      label: "Spent Qty",
                                      value: `${product.spent_qty ?? "0"}`,
                                    },
                                    {
                                      label: "Spent Amount",
                                      value: `₹ ${numberFormat(product.spent_amount_formatted ?? "0")}`,
                                    },

                                    {
                                      label: "Committed Qty",
                                      value: `${product.committed_qty ?? "0"}`,
                                    },
                                    {
                                      label: "Committed Amount",
                                      value: `₹ ${numberFormat(product.committed_amount_formatted ?? "0")}`,
                                    },

                                    {
                                      label: "CTC Amount",
                                      value: `₹ ${numberFormat(product.ctc_amount_formatted ?? "0")}`,
                                    },

                                    {
                                      label: "Balance Qty",
                                      value: `${product.balance_qty ?? "0"}`,
                                    },
                                    {
                                      label: "Balance Amount",
                                      value: `₹ ${numberFormat(product.balance_amount_formatted ?? "0")}`,
                                    },
                                    {
                                      label: "Transaction",
                                      value: `${product.trans_count ?? "0"}`,
                                    },
                                  ].map((item, idx, arr) => (
                                    <div
                                      key={idx}
                                      className="px-3 text-center py-2"
                                      style={{
                                        borderRight: idx !== arr.length - 1 ? "1px solid #EBEBEB" : "none",
                                      }}
                                    >
                                      <small className="cardTextGrey fs-12 fw-400 d-block">{item.label}</small>
                                      <span className="fs-14 fw-400">{item.value}</span>
                                    </div>
                                  ))}
                                </div>

                                {/* Toggle icon */}

                                <div className="px-3 d-flex align-items-center gap-2">
                                  {" "}
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowEditId(product.id);
                                    }}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "100px",
                                      backgroundColor: "#FFFFFF",
                                      cursor: "pointer",
                                      border: "0.8px solid #E5E5E5",
                                    }}
                                  >
                                    <EditIc />
                                  </div>
                                  {openCardId === product.id ? <ChevronUp className="p-2 rounded-pill" style={{ backgroundColor: "#EEEDFF" }} size={36} /> : <ChevronDown className="p-2 rounded-pill" style={{ backgroundColor: "#EEEDFF" }} size={36} />}
                                </div>
                              </div>
                            </div>
                            {/* Dropdown content */}
                            {openCardId === product.product_id && (
                              <div className="px-3 pb-3">
                                {transactions.length > 0 ? (
                                  <>
                                    <div className="cardTextGrey fs-11 fw-500 text-muted mb-2">ALL TRANSACTIONS : {transactions.length}</div>
                                    <Table hover responsive className="align-middle mb-0">
                                      <thead className="bg-light">
                                        <tr>
                                          <th>Date</th>
                                          <th>Vendor</th>
                                          <th>Amount</th>
                                          <th>Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {transactions.map((txn, index) => (
                                          <tr key={index}>
                                            <td className="fs-13 fw-400">{txn.date}</td>
                                            <td className="d-flex align-items-center gap-2 fs-13 fw-400">
                                              <div className="profile-wrapper-view backgroundLitgrey">
                                                <img
                                                  src={product.image && product.image.trim() !== "" ? product.image : profileIc}
                                                  alt="Profile"
                                                  className="profile-img-view"
                                                  style={{
                                                    width: "22px",
                                                    height: "22px",
                                                  }}
                                                />
                                              </div>
                                              {txn.vendor}
                                            </td>
                                            <td className="fs-13 fw-400">{numberFormat(txn.amount)}</td>
                                            <td className="fs-13 fw-400">{numberFormat(txn.qty)}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  </>
                                ) : (
                                  <div className="cardTextGrey fs-11 fw-500 text-muted mb-2">NO TRANSACTIONS FOUND</div>
                                )}
                              </div>
                            )}
                          </Card>
                        ))}
                  </div>
                </div>
              )}
              <Modal show={show} onHide={() => setShow(false)} centered size="xl">
                <div className="m-2 bg-white rounded-4 p-3">
                  <div className="row">
                    <div className="col-12 ">
                      <div className="row">
                        <div className="col-xl-12">
                          <p className="fs-18 fw-600 mb-0">{activeTab} - Products </p>
                        </div>
                        <div style={{ overflowY: "visible" }}>
                          <div className="mt-2">
                            <table
                              cellPadding="10"
                              style={{
                                width: "100%",
                              }}
                            >
                              <thead
                                style={{
                                  height: "48px",
                                  backgroundColor: "#F2F2F2",
                                  color: "#212129",
                                  fontSize: "13px",
                                  fontWeight: "700",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  {/* <th style={{ width: "5%", borderTopLeftRadius: "8px" }}>
                                  <input type="checkbox" checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} />
                                </th> */}
                                  <th className="ps-2">Product Name</th>
                                  <th className="ps-2">Unit</th>
                                  <th className="ps-2">Quantity</th>
                                  <th className="ps-2">Amount</th>
                                  <th className="sticky-col" style={{ borderTopRightRadius: "8px" }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {productList.map((r, index) => (
                                  <tr
                                    key={r.id ?? index}
                                    style={{
                                      height: "60px",
                                      border: "none",
                                      backgroundColor: "#FFFFFF",
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      color: "#212129",
                                    }}
                                  >
                                    {/* <td>
                                    <input type="checkbox" checked={selectedProducts.includes(r.id)} onChange={(e) => handleProductSelect(r.id, e.target.checked)} />
                                  </td> */}
                                    <td className="px-2 py-1">
                                      <CommonDropdown
                                        apiUrl={`${apiUrl}get_product?term=`}
                                        placeholder="Select"
                                        value={r.product}
                                        onSelect={(item) => {
                                          const tmp = [...productList];
                                          console.log("item selected", item);
                                          tmp[index] = {
                                            ...tmp[index],
                                            product: item,
                                          };
                                          setProductList(tmp);
                                        }}
                                      />
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: 400,
                                          color: "#FF4444",
                                        }}
                                      >
                                        {getErrorMsg(index, "product_id")}
                                      </span>
                                    </td>
                                    <td className="px-2 py-1">
                                      <CommonDropdown
                                        apiUrl={`${apiUrl}get_uom?term=`}
                                        placeholder="Select"
                                        value={r.unit}
                                        onSelect={(item) => {
                                          const tmp = [...productList];
                                          console.log("item selected", item);
                                          tmp[index] = {
                                            ...tmp[index],
                                            unit: item,
                                          };
                                          setProductList(tmp);
                                        }}
                                      />
                                      <span className="fs-12 fw-500 cardTextRed">{getErrorMsg(index, "unit_id")}</span>
                                    </td>
                                    <td>
                                      <div className="mx-2" style={{ minWidth: "124px" }}>
                                        <input
                                          type="text"
                                          className="form-control rounded-3 vendor-form-input"
                                          id={`Quantity` + index}
                                          placeholder="Enter here"
                                          value={r.quantity}
                                          onChange={(e) => {
                                            const productTemp = [...productList];
                                            productTemp[index] = {
                                              ...productTemp[index],
                                              quantity: e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"),
                                            };
                                            setProductList(productTemp);
                                          }}
                                        />
                                        <span className="fs-12 fw-500 cardTextRed">{getErrorMsg(index, "qty")}</span>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="mx-2" style={{ minWidth: "124px" }}>
                                        <input
                                          type="text"
                                          className="form-control rounded-3 vendor-form-input"
                                          id={`Amount` + index}
                                          placeholder="Enter here"
                                          value={r.amount}
                                          onChange={(e) => {
                                            const productTemp = [...productList];
                                            productTemp[index] = {
                                              ...productTemp[index],
                                              amount: e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"),
                                            };
                                            setProductList(productTemp);
                                          }}
                                        />
                                      </div>
                                      <span className="fs-12 fw-500 cardTextRed">{getErrorMsg(index, "amount")}</span>
                                    </td>
                                    <td className="sticky-col">
                                      <div className="mx-2 ps-2 d-flex align-items-center">
                                        <img
                                          src={deleteIc}
                                          alt="delete"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (r.id !== null && r.id !== 0 && r.id !== "") {
                                              setRemovedProductList((prev) => [...prev, r.id]);
                                            }
                                            const productListTemp = [...productList];
                                            productListTemp.splice(index, 1);
                                            setProductList(productListTemp);
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-xl-12 mt-2">
                          <Button
                            className={`cursor-pointer border-0 rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                            onClick={() => {
                              setProductList([
                                ...productList,
                                {
                                  id: 0,
                                  product: null,
                                  product_code: null,
                                  unit: null,
                                  quantity: null,
                                  amount: null,
                                },
                              ]);
                            }}
                            style={{
                              minWidth: "100px",
                              background: "#E6E4FF",
                              color: "#212129",
                              fontWeight: "600",
                              fontSize: "13px",
                            }}
                          >
                            Add product
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Modal.Footer>
                  <button
                    onClick={() => {
                      setRemovedProductList([]);
                      setSelectAll(false);
                      setSelectedProducts([]);
                      setShow(false);
                      setActiveRevision((prev) => ({ ...prev, products: [] }));
                    }}
                    className="rounded-pill px-4 py-1 bg-transparent fs-15 fw-500 textcolor"
                    style={{ border: "1px solid #D4DDE7", height: "40px" }}
                  >
                    Cancel
                  </button>
                  <button className="backgroundPrimary rounded-pill px-4 py-1 text-white border-0 fs-15 fw-500 " onClick={isLoading ? null : submitBudgets} style={{ height: "40px" }}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : "Save"}
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
